/* import __COLOCATED_TEMPLATE__ from './doughnut-chart-section.hbs.js'; */
import Component from '@glimmer/component';
export default class DoughnutChartSection extends Component {
  get chartId() {
    return this.args.chartId;
  }
  get chartData() {
    return this.args.chartData;
  }
  get chartBreakdown() {
    return this.args.chartBreakdown;
  }
  get sectionDescription() {
    return this.args.sectionDescription;
  }
  get chartTitle() {
    return this.args.chartTitle;
  }
  get chartSubTitle() {
    return this.args.chartSubTitle;
  }
  get chartOptions() {
    return this.args.chartOptions;
  }
}